module.exports = __webpack_public_path__ + "static/media/nebel.0fdc9e9b.png";